import { FC } from 'react';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableCell from '@mui/material/TableCell';
import { Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { CellRender } from '../../../Cell';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sortLabel: {
      '&:hover': {
        color: theme.palette.text.secondary,
        cursor: 'pointer',
        '& .MuiTableSortLabel-icon': {
          opacity: 0.5,
        },
      },
    },
  })
);

/**
 * @summary Для функций сортировки используем число, а для отображения - буквенные константы.
 *
 * @param sortDir - Направление сортировки в виде числа. Если число больше нуля, то сортировка
 * по возрастранию. В других случаях - по убыванию.
 */
const convertorOrder = (sortDir: number) => (sortDir > 0 ? 'asc' : 'desc');

type Props = {
  cell: CellRender<any>;
  sortDirection: { sortCol: string; sortDir: number };
  setSortDirection: (
    updateSortDirectionFunction: (setting: {
      sortCol: string;
      sortDir: number;
    }) => {
      sortCol: string;
      sortDir: number;
    }
  ) => void;
  addClass: {
    root: string;
  };
};

/**
 * @summary Ячейка заголовка с включенной сортировкой.
 *
 * @param cell - Текущая ячейка.
 * @param sortDirection - Текущие настройки сортировки. Сохраняются в localStorage.
 * @param setSortDirection - Установить новые настройки сортировки.
 * @param addClass - Стили для заголовка с сортировкой.
 */
export const TableHeadCell: FC<Props> = ({ cell, sortDirection, setSortDirection, addClass }) => {
  const classes = useStyles();

  const sortDirectionHandler = () => {
    setSortDirection((setting) => {
      /** При нажатии на активный столбец направление сортировки изменяется. */
      if (cell.props.columnName === setting.sortCol) {
        return {
          ...setting,
          sortDir: setting.sortDir * -1,
        };
      }
      return {
        ...setting,
        sortCol: cell.props.columnName,
      };
    });
  };

  return (
    <TableCell
      sortDirection={
        cell.props.columnName === sortDirection.sortCol
          ? convertorOrder(sortDirection.sortDir)
          : false
      }
      className={addClass.root}
    >
      {cell.props.headtitleComponent ? (
        <Box display="flex" className={classes.sortLabel}>
          {cell.props.headtitleComponent({
            headtitle: cell.props.headtitle,
            sortDirectionHandler,
          })}
          <TableSortLabel
            style={{ flexGrow: 1 }}
            active={cell.props.columnName === sortDirection.sortCol}
            direction={convertorOrder(sortDirection.sortDir)}
            onClick={sortDirectionHandler}
          />
        </Box>
      ) : (
        <TableSortLabel
          active={cell.props.columnName === sortDirection.sortCol}
          direction={convertorOrder(sortDirection.sortDir)}
          onClick={sortDirectionHandler}
        >
          {cell.props.headtitle}
        </TableSortLabel>
      )}
    </TableCell>
  );
};
